import script from "./CourseDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseDetails.vue?vue&type=script&setup=true&lang=js"

import "./CourseDetails.vue?vue&type=style&index=0&id=70abf527&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70abf527"]])

export default __exports__